import React from 'react'
import { Paper, Typography, Box, IconButton, makeStyles } from '@material-ui/core'
import { Add, Search, Cancel, FilterList } from '@material-ui/icons'
import classNames from 'classnames'
import Button from '../Button'
import TextInput from '../TextInput'

const useStyles = makeStyles(() => ({
  fixedToolbar: {
    zIndex: 1,
    backgroundColor: 'white',
    position: 'fixed',
    top: '70px',
    left: 0,
    right: 0,
  },
}))

const ToolbarWrapper = ({ children, ...overrides }) => {
  const classes = useStyles()
  const toolbarConfig = {
    className,
    square: true,
    marginBottom: 24,
    newFilterButton: false,
    searchOpen: false,
    searchCloseButton: true,
    searchInput: <TextInput autoFocus variant="outlined" placeholder="Search..." size="small" />,
    filterOpen: false,
    filterCloseButton: true,
    filterInput: <TextInput autoFocus variant="outlined" placeholder="Filter by..." size="small" />,
    shiftActionButton: false,
    fixedToolbar: false,
    ...overrides,
  }
  const ButtonProps = overrides.ButtonProps
  const className = toolbarConfig.className
  const pageTitle = toolbarConfig.pageTitle
  const searchButton = toolbarConfig.searchButton
  const searchButtonAction = toolbarConfig.searchButtonAction
  const searchOpen = toolbarConfig.searchOpen
  const searchInput = toolbarConfig.searchInput
  const searchCloseButton = toolbarConfig.searchCloseButton
  const searchCloseAction = toolbarConfig.searchCloseAction
  const filterButton = toolbarConfig.filterButton
  const filterButtonAction = toolbarConfig.filterButtonAction
  const filterOpen = toolbarConfig.filterOpen
  const filterInput = toolbarConfig.filterInput
  const filterCloseButton = toolbarConfig.filterCloseButton
  const filterCloseAction = toolbarConfig.filterCloseAction
  const actionButton = toolbarConfig.actionButton
  const actionButtonTitle = toolbarConfig.actionButtonTitle
  const actionButtonAction = toolbarConfig.actionButtonAction
  const marginBottom = toolbarConfig.marginBottom
  const newFilterButton = toolbarConfig.newFilterButton
  const shiftActionButton = toolbarConfig.shiftActionButton
  const square = toolbarConfig.square
  const fixedToolbar = toolbarConfig.fixedToolbar

  const filterLayout = () => {
    if (newFilterButton) {
      return <React.Fragment>{filterInput}</React.Fragment>
    } else if (filterOpen) {
      return (
        // Display field
        <Box className="InputContainer">
          {filterInput}
          {filterCloseButton && (
            <IconButton className="CloseButton" onClick={filterCloseAction} size="small">
              <Cancel />
            </IconButton>
          )}
        </Box>
      )
    } else {
      return (
        // Display filter button
        <IconButton className="ToolbarButton" onClick={filterButtonAction}>
          <FilterList />
        </IconButton>
      )
    }
  }

  return (
    <Paper
      className={classNames('Toolbar', { [classes.fixedToolbar]: fixedToolbar })}
      style={{ marginBottom: marginBottom }}
      square={square}
    >
      {/* Title */}
      {pageTitle && (
        <Box paddingRight={2}>
          <Typography variant="h6">{pageTitle}</Typography>
        </Box>
      )}
      {/* Search and Filter */}
      {(searchButton || filterButton) && (
        <Box paddingRight={2} display="flex">
          {/* Search */}
          {searchButton && (
            <Box paddingRight={1}>
              {searchOpen ? (
                // Display field
                <Box className="InputContainer">
                  {searchInput}
                  {searchCloseButton && (
                    <IconButton className="CloseButton" onClick={searchCloseAction} size="small">
                      <Cancel />
                    </IconButton>
                  )}
                </Box>
              ) : (
                // Display filter button
                <IconButton className="ToolbarButton" onClick={searchButtonAction}>
                  <Search />
                </IconButton>
              )}
            </Box>
          )}
          {/* Filter */}
          {filterButton && <Box>{filterLayout()}</Box>}
        </Box>
      )}
      {/* Other content */}
      <Box flexGrow={1}>{children}</Box>
      {/* CTA button */}
      {actionButton && (
        <Box>
          <Button
            className={shiftActionButton ? className : null}
            startIcon={<Add />}
            onClick={actionButtonAction}
            {...ButtonProps}
          >
            {actionButtonTitle}
          </Button>
        </Box>
      )}
    </Paper>
  )
}

export default ToolbarWrapper
